import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import Logo from "./../../assets/MainLogo.svg";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import moment from "moment";
import "./PrintBillModal.scss";

const PrintBillModal = ({ open, onClose, order }) => {
  const handlePrint = () => {
    window.print();
  };

  if (!order) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="print-bill-modal"
    >
      <DialogTitle className="dialog-title">
        <div className="title-container">
          <h2>فاتورة الطلب</h2>
          <IconButton onClick={onClose} className="close-button">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className="dialog-content print-content">
        {/* Header Section */}
        <div className="bill-header">
          <div className="company-info">
            <h3>مؤسسة حوف المنازل</h3>
            <p>العنوان: شارع مسقط، رفحا</p>
            <p>الهاتف: 966532571702</p>
          </div>
          <div className="invoice-info">
            <p>
              <strong>رقم الفاتورة:</strong> {order?.orderNumber}
            </p>
            <p>
              <strong>التاريخ:</strong>{" "}
              {moment(order?.createdAt).locale("en").format("DD/MM/YYYY")}
            </p>
            <p>
              <strong>الوقت:</strong>{" "}
              {moment(order?.createdAt).locale("en").format("hh:mm A")}
            </p>
          </div>
        </div>

        {/* Customer Info */}
        <div className="customer-info">
          <h4>معلومات العميل</h4>
          <p>
            <strong>الاسم:</strong> {order?.user?.name}
          </p>
          <p>
            <strong>رقم الهاتف:</strong> {order?.user?.phoneNumber}
          </p>
          <p>
            <strong>العنوان:</strong> {order?.bookingAddress?.street},{" "}
            {order?.bookingAddress?.city}
          </p>
          <p>
            <strong>طريقة الدفع:</strong> {order?.paymentMethod}
          </p>
        </div>

        {/* Services Table */}
        <TableContainer component={Paper} className="services-table">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="right">م</TableCell>
                <TableCell align="right">الخدمة</TableCell>
                <TableCell align="right">السعر</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order?.services?.map((service, index) => (
                <TableRow key={service._id}>
                  <TableCell align="right">{index + 1}</TableCell>
                  <TableCell align="right">{service?.name?.ar}</TableCell>
                  <TableCell align="right">{service?.price} ريال</TableCell>
                </TableRow>
              ))}

              {order?.promoCode?.discount && (
                <TableRow>
                  <TableCell align="right" colSpan={2}>
                    الخصم
                  </TableCell>
                  <TableCell align="right">
                    {order?.promoCode?.discount}- ريال
                  </TableCell>
                </TableRow>
              )}

              <TableRow className="total-row">
                <TableCell align="right" colSpan={2}>
                  <strong>الإجمالي</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{order?.totalPrice?.totalPrice} ريال</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Footer */}
        <div className="bill-footer">
          <p>شكراً لاختياركم خدماتنا</p>
          <p>نتطلع لخدمتكم مرة أخرى</p>
          <img src={Logo} alt="" width={160} />
        </div>

        {/* Print Button */}
        <div className="print-button-container hide-on-print">
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
            className="print-button"
          >
            طباعة
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrintBillModal;
